<template>
  <v-container>
    <btn-a
      class="ma-2"
      outlined
      rounded
      color="primary"
      @click="stageDialogOpen"
    >
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-list two-line subheader v-if="value.stages">
      <div v-for="(item, i) in value.stages" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title v-text="item.description"></v-list-item-title>
            <v-list-item-subtitle v-text="item.seq"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="stageDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="stageRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="value.stages && value.stages.length > 0"></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="stageDialog"
      :title="$tc('entities.stage.title')"
      @confirm="stageConfirm"
      @cancel="stageDialogCancel"
    >
      <stageForm v-model="stageSelected" ref="form"></stageForm>
    </dialog-d>
  </v-container>
</template>


<script>
import stageForm from "./stageForm";
export default {
  components: { stageForm },
  props: {
    value: {
      default: () => {
        return {
          description: "",
          stages: []
        };
      }
    }
  },
  data() {
    return {
      stageSelected: {},
      stageSelectedRef: null,
      resources: [],
      stageTypes: []
    };
  },

  watch: {
    async value() {
      //await this.getResources();
      //await this.getStageTypes();
    }
  },
  methods: {
    async getResources() {
      let res = await this.$http.get("resource");
      if (res.success) this.resources = res.data.data;
    },
    async getStageTypes() {
      let res = await this.$http.get("stageType");
      if (res.success) this.stageTypes = res.data.data;
    },
    stageDialogCancel() {
      this.stageSelectedRef = null;
    },
    stageConfirm() {
      if (!this.$refs.form.isValid()) return;
      if (this.stageSelectedRef) {
        Object.assign(this.stageSelectedRef, this.stageSelected);
      } else {
        this.value.stages.push(this.stageSelected);
      }
      this.$refs.stageDialog.open();
      this.stageSelectedRef = null;
    },
    async stageRemove(stage) {
      if(!(await this.$confirm())) return;
      let index = this.value.stages.indexOf(stage);
      if (index >= 0) this.value.stages.splice(index, 1);
    },
    stageDialogOpen(stage) {
      if (stage) {
        this.stageSelectedRef = stage;
        let obj = {};
        Object.assign(obj, stage);
        this.stageSelected = obj;
      } else {
        this.stageSelected = { stageItemsCons: [], stageItemsProd: [] };
      }

      this.$refs.stageDialog.open();
    }
  },
  async mounted() {
    //await this.getResources();
    //await this.getStageTypes();
  }
};
</script>